// import React from 'react'
// import { Button} from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import {VERSION} from './../../url/index';
// import './../CSS/form.css';
// import './../../App.css'


// export default function HomePage(props) {
//     const navigate = useNavigate();
//     const handleClick = (id) => {
//         navigate(`/register/${id}`);
//     }

//     const handleScholarship = () => {
//       navigate(`/scholarship`);
//     }

//     const handleSchool = (id) => {
//       navigate(`/school/${id}`);
//     }
//     const handleNursing = () => {
//       navigate(`/nursing`);
//     }
  
//   return (
//     <div>
//  <div className='title'>
//     <label>Welcome To CTG Group Of Institutions</label>
//   </div>

// <div className='AppHome' >
// <div className="button-container">
  
//     <div className="button-section-left">
//       <ButtonSection onClick={() => handleClick(1)} text="Click Here to Register for +2 Course" />
//       <ButtonSection onClick={() => handleClick(2)} text="Click Here to Register for +3 Course" />
//       <ButtonSection onClick={handleScholarship} text="Click Here to Register for Scholarship Programme" />
//       <ButtonSection onClick={handleNursing} text="Click Here to Register for Nursing Programme" />
//     </div>

//     <div className="button-section-right">
//       <ButtonSection onClick={() => handleSchool(1)} text="Click Here to Register for CTG Global School (Eng. Medium)" />
//       <ButtonSection onClick={() => handleSchool(2)} text="Click Here to Register for CTG Vidya Mandir (Odia Medium)" />
//       <ButtonSection onClick={() => handleClick(3)} text="Click Here to Register for MBA/MCA/BBA/BCA/MFC/MSW/B.LIB Course"/>
//     </div>
//   </div>
// </div>


  

//   <label className="bottomright">{VERSION}</label>
// </div>
//   )
// }

// const ButtonSection = ({ onClick, text }) => (
//   <p>
//     <Button className="btn btn-light" style={{ width: "80%" }} onClick={onClick}>
//       <b style={{ color: "green" }}>{text}</b>
//     </Button>
//   </p>
// );



import React from 'react';
import { useNavigate } from 'react-router-dom';
import { VERSION } from './../../url/index';
import CTGLogo from '../../Components/Img/logo.png';


const GOLD = '#d4aa50';

const programs = [
  { id: 'plus2',      label: '+2 Course',            desc: 'Intermediate / Junior College',      icon: '📘', nav: '/register/1' },
  { id: 'plus3',      label: '+3 Course',             desc: 'Undergraduate Degree Programme',     icon: '🎓', nav: '/register/2' },
  { id: 'pg',         label: 'MBA / MCA / BBA / BCA', desc: 'MFC · MSW · B.LIB & more',           icon: '💼', nav: '/register/3' },
  { id: 'nursing',    label: 'Nursing Programme',     desc: 'Professional Healthcare Training',   icon: '🩺', nav: '/nursing' },
  { id: 'eng-school', label: 'CTG Global School',     desc: 'English Medium',                     icon: '🏫', nav: '/school/1' },
  { id: 'odia-school',label: 'CTG Vidya Mandir',      desc: 'Odia Medium',                        icon: '🪔', nav: '/school/2' },
  { id: 'scholarship',label: 'Scholarship Programme', desc: 'Merit & Need-Based Awards',          icon: '🏅', nav: '/scholarship' },
];

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <div style={s.wrap}>
      <div style={s.hero}>
        <div style={s.geo1} /><div style={s.geo2} />
{/* <div style={s.logoCircle}>
  <img src={CTGLogo} alt="CTG Logo" style={s.logoImg} />
</div> */}
<div style={s.geo3} />
        <div style={s.badge}>
          <span style={s.dot} />
          <span style={s.badgeText}>
  Admissions Open{' '}
  {(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const start = month >= 6 ? year : year - 1;
    return `${start}–${String(start + 1).slice(-2)}`;
  })()}
</span>
        </div>
        <h1 style={s.title}>CTG Group<br /><em style={s.em}>of Institutions</em></h1>
        <p style={s.sub}>Choose a programme below to start your registration</p>
      </div>
      <div style={s.divLine} />
      <p style={s.sectionLabel}>Academic Programmes</p>
      <div style={s.grid}>
        {programs.map(p => <Card key={p.id} prog={p} onClick={() => navigate(p.nav)} />)}
      </div>
      <div style={s.footer}>
        <span style={s.footerText}>{VERSION}</span>
        <span style={s.footerText}>© {new Date().getFullYear()} CTG Group of Institutions</span>
      </div>
    </div>
  );
}

function Card({ prog, onClick }) {
  const [hov, setHov] = React.useState(false);
  return (
    <button
      style={{ ...s.card, ...(hov ? s.cardHov : {}) }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onClick}
    >
      <div style={{ ...s.iconRing, ...(hov ? s.iconRingHov : {}) }}>
        <span style={{ fontSize: 19 }}>{prog.icon}</span>
      </div>
      <div style={s.body}>
        <div style={s.cardTitle}>{prog.label}</div>
        <div style={s.cardSub}>{prog.desc}</div>
      </div>
      <span style={{ ...s.arrow, ...(hov ? s.arrowHov : {}) }}>→</span>
    </button>
  );
}

const s = {
  wrap:       { fontFamily: "'DM Sans','Segoe UI',sans-serif", background: '#0a0f1a', minHeight: '100vh', paddingBottom: '2rem' },
  hero:       { padding: '3rem 2.5rem 2.5rem', position: 'relative', overflow: 'hidden' },
  geo1:       { position:'absolute', top:-60, right:-60, width:320, height:320, borderRadius:'50%', border:`1px solid rgba(212,170,80,0.08)`, pointerEvents:'none' },
  geo2:       { position:'absolute', top:20, right:40, width:180, height:180, borderRadius:'50%', border:`1px solid rgba(212,170,80,0.12)`, pointerEvents:'none' },
  geo3:       { position:'absolute', bottom:-40, left:-40, width:200, height:200, borderRadius:'50%', border:`1px solid rgba(212,170,80,0.05)`, pointerEvents:'none' },
  badge:      { display:'inline-flex', alignItems:'center', gap:6, background:'rgba(212,170,80,0.1)', border:'1px solid rgba(212,170,80,0.25)', borderRadius:100, padding:'5px 14px', marginBottom:'1.5rem' },
  dot:        { display:'inline-block', width:6, height:6, borderRadius:'50%', background: GOLD, flexShrink:0 },
  badgeText:  { fontSize:11, fontWeight:500, color: GOLD, letterSpacing:'0.08em', textTransform:'uppercase' },
  title:      { fontFamily:"'Playfair Display',Georgia,serif", fontSize:'2.8rem', fontWeight:700, color:'#fff', lineHeight:1.1, marginBottom:'0.6rem' },
  em:         { fontStyle:'italic', color:'rgba(212,170,80,0.6)' },
  sub:        { fontSize:'0.9rem', color:'rgba(255,255,255,0.4)', fontWeight:300, letterSpacing:'0.02em' },
  divLine:    { height:1, background:'linear-gradient(to right,rgba(212,170,80,0.3),transparent)', margin:'2rem 2.5rem' },
  sectionLabel:{ fontSize:10, fontWeight:500, letterSpacing:'0.15em', textTransform:'uppercase', color:'rgba(212,170,80,0.45)', padding:'0 2.5rem', marginBottom:'1rem' },
  grid:       { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(270px,1fr))', gap:10, padding:'0 2.5rem' },
  card:       { background:'#111827', border:'1px solid rgba(212,170,80,0.1)', borderRadius:16, padding:'1.3rem 1.4rem', cursor:'pointer', transition:'all 0.22s cubic-bezier(0.34,1.56,0.64,1)', display:'flex', alignItems:'center', gap:14, textAlign:'left', width:'100%' },
  cardHov:    { background:'#16202f', borderColor:'rgba(212,170,80,0.4)', transform:'translateY(-3px) scale(1.01)' },
  iconRing:   { width:44, height:44, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, background:'rgba(212,170,80,0.08)', border:'1px solid rgba(212,170,80,0.15)', transition:'all 0.22s ease' },
  iconRingHov:{ background:'rgba(212,170,80,0.15)', transform:'rotate(-6deg) scale(1.1)' },
  body:       { flex:1, minWidth:0 },
  cardTitle:  { fontSize:'0.88rem', fontWeight:500, color:'#f1e8cc', lineHeight:1.3, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' },
  cardSub:    { fontSize:'0.72rem', color:'rgba(212,170,80,0.6)', marginTop:2, fontWeight:400 },
  arrow:      { fontSize:18, color:'rgba(212,170,80,0.25)', flexShrink:0, transition:'all 0.2s ease' },
  arrowHov:   { color: GOLD, transform:'translateX(4px)' },
  footer:     { padding:'1.5rem 2.5rem 0', display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'1px solid rgba(212,170,80,0.08)', marginTop:'1.5rem' },
  footerText: { fontSize:11, color:'rgba(212,170,80,0.25)', fontWeight:300 },
  logoCircle: {
    position: 'absolute', top: 20, right: 40,
    width: 180, height: 180, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    overflow: 'hidden',
    pointerEvents: 'none',
  },
  logoImg: {
    width: 120, height: 120,
    objectFit: 'contain',
    opacity: 0.85,
  }
};

